import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { Quality } from '../models';
import { BaseEditService } from './base';

@Injectable({
  providedIn: 'root',
})
export class QualityService extends BaseEditService<Quality, Quality> {
  readonly qualitySelected$ = new Subject<string>();

  // Fired after the Details form saves: the weaving screens stay open on save and the
  // host re-reads its model so the whole screen refreshes in place (R5, Steve 2026-09-09).
  public refreshDetails = new Subject<void>();

  constructor() {
    super('Quality', $localize`Quality`);
  }

  // The Loom Spec cascade for the UNSAVED form values (Steve, 2026-10-09): the server
  // works the lengths/dents/widths out and hands them back without saving - deliberately
  // a button round trip, not live per-field recalculation, which is how screens get
  // circular-update hangs (see ui.md, updateModel inside effect()).
  calculate(model: any): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Calculate`, model);
  }
}
